import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useActivityState } from '@praktio/common-ui';
import { sendHeartbeat } from '../../../utils/websocket';

const HEARTBEAT_INTERVAL_MS = 30000;

interface IProps {
  context?: string;
}

const PresenceHeartbeat = ({ context }: IProps) => {
  const { state } = useActivityState();
  const { pathname } = useLocation();

  useEffect(() => {
    sendHeartbeat(state, context, pathname);
    const tick = setInterval(() => sendHeartbeat(state, context, pathname), HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(tick);
  }, [state, context, pathname]);

  return null;
};

export default PresenceHeartbeat;
